var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPictureInPictureOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "picture-in-picture-on_svg__icon picture-in-picture-on_svg__icon-tabler picture-in-picture-on_svg__icon-tabler-picture-in-picture-on",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 14,
  width: 7,
  height: 5,
  rx: 1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m7 9 4 4M8 13h3v-3"
})));
export default SvgPictureInPictureOn;